export function staffEntryRestriction(staffMayExhibit: boolean, isShowStaff?: boolean) {
  if (staffMayExhibit || isShowStaff === false) return undefined
  return isShowStaff === true
    ? 'Show staff may not enter their own exhibits in this show.'
    : 'Connect to verify this entrant’s staff eligibility before adding or checking in entries.'
}

export class EntryEligibilityError extends Error {}
